import { Object3D, Vector3, Mesh } from "three";
import { MaterialManager } from "../../material/MaterialManager";
import { AddonManager } from "../../scene/addon/AddonManager";
import { Main } from "../../Main";

export interface ISlopeTrimConfig
{
	rotation   : number;
	flip     ? : boolean;
	parent     : Object3D;
}

export class SlopeTrim
{

	private _config    : ISlopeTrimConfig;
	private _container : Object3D;
	private _mesh      : Mesh;

	constructor(config:ISlopeTrimConfig)
	{
		this._config = config;
		this.init();
	}

	private init()
	{
		var meshName = "#1440 - Sculptured Rake Trim - scalable";

		if (this._config.flip)
		{
			meshName += "_flipped";
		}

		this._container = new Object3D();

		var material = MaterialManager.getInstance().trim;
		this._mesh = AddonManager.getInstance().createMesh(meshName, material) as Mesh;
		this._mesh.position.x = 0.5;
		this._mesh.rotation.x = Math.PI;
		this._mesh.rotation.z = Math.PI + this._config.rotation;
		this._mesh.castShadow = true;

		this._container.add(this._mesh);
		this._config.parent.add(this._container);
	}

	// this also gets called in BuildingTrim.updateRoofTrim when single slope changes
	public update(position:Vector3, length:number, pitch:number, negate_alpha:boolean = false)
	{
		var tan = pitch/12;
		var alpha = Math.atan(tan);

		// so avoid overlap with peakbox
		//length = length - 0.5;

		var adjacent_side = length - 0.5 - 0.2;
		var opposite_side = tan * adjacent_side;
		var scale_x = Math.sqrt(adjacent_side*adjacent_side + opposite_side*opposite_side);

		// extend scale in case of single_slope to make sure the 2 sides overlap and there's no hole
		var scale_padding = 0;

		var single_slope = Main.getInstance().config.building.single_slope.value;
		if (single_slope && single_slope)
		{
			scale_padding = 1.5;
		}

		this._mesh.scale.x = scale_x * AddonManager.DEFAULT_SCALE + scale_padding;
		this._container.rotation.z = negate_alpha ? alpha : -alpha;

		this._container.position.set(position.x, position.y, position.z);
	}

	public show()
	{
		this._mesh.visible = true;
	}

	public hide()
	{
		this._mesh.visible = false;
	}
}
